module.exports = __webpack_public_path__ + "./fonts/DINNextLTPro-Bold.ttf";